export default "__VITE_ASSET__ECzI4K_U__"